import { render, staticRenderFns } from "./NotesButton.vue?vue&type=template&id=0c662ca8&scoped=true"
import script from "./NotesButton.vue?vue&type=script&lang=ts"
export * from "./NotesButton.vue?vue&type=script&lang=ts"
import style0 from "./NotesButton.vue?vue&type=style&index=0&id=0c662ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c662ca8",
  null
  
)

export default component.exports